<template>
  <div :key="network.id">
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'network',
        ]),
    },
    async beforeRouteUpdate(to, from, next) {
        if (from.params.networkId !== to.params.networkId) {
            if (await this.getNetworkInfo(to.params.networkId)) {
                next();
            }
        } else {
            next();
        }
    },
    methods: {
        ...mapActions({
            getNetworkInfo: 'getNetworkInfo',
        }),
    },
};
</script>
